export default {
  'Sample photo': 'Foto Campione',
  Removing: 'Rimozione in corso',
  Edit: 'Modifica',
  'Adjust Picture': 'Regola Immagine',
  Restore: 'Ripristino',
  Eraser: 'Gomma',
  Size: 'Dimensione',
  Background: 'Sfondo',
  Custom: 'Generico',
  Presets: 'Predefinito',
  'Add Image': 'Aggiungi Immagine',
  'Scale to Fit': 'Scala per adattarsi',
  'Full Width': 'Larghezza Piena',
  'Full Height': 'Altezza Piena',
  Move: 'Muovi',
  Undo: 'Ritirato',
  Redo: 'Recupero',
  Enlarge: 'Ingrandisci',
  Reduce: 'Riduci',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw Online Rimozione Sfondo',
    desc: 'Rimuovere facilmente lo sfondo delle tue foto al 100% in modo automatico e gratis',
    imgAlt: 'photo background remover',
    submitBtn: 'Rimuovere lo Sfondo',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
